import axios from '@/lib/axios';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

type OptionType = { value: number; label: string };

interface Props {
  setValue: any;
  watch: any;
}

export default function AddressSelect({ setValue, watch }: Props) {
  const [cities, setCities] = useState<OptionType[]>([]);
  const [zones, setZones] = useState<OptionType[]>([]);
  const [areas, setAreas] = useState<OptionType[]>([]);

  const cityId = watch('shipping_city_id');
  const zoneId = watch('shipping_zone_id');
  const areaId = watch('shipping_area_id');

  // Fetch cities
  useEffect(() => {
    axios.get('/api/v2/cities-by-country/1').then((res) => {
      const options = res.data.data.cities.map((city: any) => ({
        value: city.id,
        label: city.name,
      }));
      setCities(options);
    });
  }, []);

  // Fetch zones when city changes
  useEffect(() => {
    if (cityId) {
      axios.get(`/api/v2/zones-by-city/${cityId}`).then((res) => {
        const options = res.data.data.zones.map((zone: any) => ({
          value: zone.id,
          label: zone.name,
        }));
        setZones(options);
      });
    }
  }, [cityId]);

  // Fetch areas when zone changes
  useEffect(() => {
    if (zoneId) {
      axios.get(`/api/v2/areas-by-zone/${zoneId}`).then((res) => {
        const options = res.data.data.areas.map((area: any) => ({
          value: area.id,
          label: area.name,
        }));
        setAreas(options);
      });
    }
  }, [zoneId]);

  return (
    <div className="col-12" style={{ zIndex: 100 }}>
      <div className="row g-3">
        <div className="col-lg-4">
          <Select
            options={cities}
            value={cities.find((c) => c.value === cityId) || null}
            onChange={(option) => {
              setValue('shipping_city_id', option?.value ?? null);
              setValue('shipping_zone_id', null);
              setValue('shipping_area_id', null);
            }}
            placeholder="City"
            className="form-control"
          />
        </div>
        <div className="col-lg-4">
          <Select
            options={zones}
            value={zones.find((z) => z.value === zoneId) || null}
            onChange={(option) => {
              setValue('shipping_zone_id', option?.value ?? null);
              setValue('shipping_area_id', null);
            }}
            placeholder="Zone"
            className="form-control"
            isDisabled={!cityId}
          />
        </div>
        <div className="col-lg-4">
          <Select
            options={areas}
            value={areas.find((a) => a.value === areaId) || null}
            onChange={(option) => {
              setValue('shipping_area_id', option?.value ?? null);
            }}
            placeholder="Area"
            className="form-control"
            isDisabled={!zoneId}
          />
        </div>
      </div>
    </div>
  );
}
